import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateImageInfoRequestModel } from "../vo/update-image-info-request.model";
import { UpdateImageInfoResponseModel } from "../vo/update-image-info-response.model";

/**
 * 画像情報管理更新 
 */
@Injectable()
export class UpdateImageInfoService extends PlessJsonResponderSub<any> {

  private imageInfoList: UpdateImageInfoRequestModel[];

  private successFunc: Function;

  private faultFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: this.imageInfoList.length === 0 ?
        {} : {
          ImageFileList: {
            combination:
              this.imageInfoList.map(_ => {
                return {
                  condition: {
                    ImageKind: _.imageKind,
                    PhotographingNo: _.photographingNo,
                    SupplierAnnouncement: _.supplierAnnouncement,
                    ImageInfoChange: _.imageInfoChange,
                    Remarks: _.remarks,
                    PhotoSchedule: _.photoSchedule,
                    PhotographingChangeSchedule: _.photographingChangeSchedule,
                    CarriedForward: _.carriedForward,
                    ImageID: _.imageID,
                    DispPhotoSchedule: _.dispPhotoSchedule,
                    C2pfTarget: _.c2pfTarget,
                    ImageFileName: _.imageFileName,
                    ClassCode: _.classCode,
                    ClassName: _.className,
                    StartOrderCode: _.startOrderCode,
                    PhotoContentsName: _.photoContentsName,
                    TempRangeName: _.tempRangeName
                  }
                }
              })
          }
        }
    });
  }

  /**
   * API呼び出し
   *
   * @param {UpdateImageInfoRequestModel[]} [imageInfoList]
   * @param {Function} [successFunc=null]
   * @memberof UpdateImageInfoService
   */
  execute(imageInfoList: UpdateImageInfoRequestModel[], successFunc: Function, faultFunc: Function = null): void {
    this.successFunc = successFunc;
    this.faultFunc = faultFunc;
    this.imageInfoList = imageInfoList;
    this.send('KYMW17UpdateImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateImageInfoService
   */
  success(data: any): void {
    if (this.successFunc !== null && data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof UpdateImageInfoService
   */
  plessErrorHandler(errList: Object): void {
    this.faultFunc();
    // 標準処理を続行
    super.plessErrorHandler(errList);
  }
}
